import { Component, OnInit } from '@angular/core';
import { LoadingService } from 'src/app/_services/loading.service';
import { NotificationService } from 'src/app/_services/notification.service';
import { ProductService } from '../_ecomservices/product.service';

@Component({
  selector: 'app-outlets',
  templateUrl: './outlets.component.html',
  styleUrls: ['./outlets.component.css']
})
export class OutletsComponent implements OnInit {

  product_list = [];
  bill: any[] = [];

  constructor(
    public productService: ProductService,
    private loading : LoadingService,
    private notificationService: NotificationService,
  ) { }

  ngOnInit() {
    this.onLoadProducts();
  }


  onLoadProducts() {
      var result = this.productService.get_products().subscribe(data=> {
        // console.log(data);
        this.product_list = data['productList'];
        console.log(this.product_list);
      });
    }

  addToBill(item: any) {
    const existing = this.bill.find(b => b.id === item.id);
    if (existing) {
      existing.qty++;
    } else {
      this.bill.push({id: item.id, name: item.prod_name, qty: 1, price: item.sale_price, image: item.primary_img});
    }
  }

  removeFromBill(index: number) {
    this.bill.splice(index, 1);
  }

  get total() {
    return this.bill.reduce((sum, item) => sum + (item.price * item.qty), 0);
  }


}
